import * as React from 'react';
import { TbUserPlus } from "react-icons/tb";
import { IoPencil, IoTrashOutline, IoSearchOutline } from "react-icons/io5";
import profile from '../../assets/profile.png';
import profile1 from '../../assets/profile1.png';
import { SuperAdminUserList, getAllMembers, logout, stringAvatar } from '../../service/service-call';
import MemberDelete from './memberDelete';
import AddMembers from './membersAdd';
import EditMembers from './membersEdit';
import ViewMembers from './membersView';
import { keyframes } from 'styled-components';
import './style.css';

export default function Members() {
  const [searchText, setSearchText] = React.useState("");
  const [isViewMemberOpen, setIsViewMemberOpen] = React.useState(false);
  const [isAddMemberOpen, setIsAddMemberOpen] = React.useState(false);
  const [isEditMemberOpen, setIsEditMemberOpen] = React.useState(false);
  const [isDeleteMemberOpen, setIsDeleteMemberOpen] = React.useState(false);
  const [members, setMembers] = React.useState([]);
  const [selectedMembers, setSelectedMembers] = React.useState({});
  const [selectedMemberId, setSelectedMemberId] = React.useState("");
  const [selectedMemberName, setSelectedMemberName] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
 

  React.useEffect(() => {
    getAllMembersByUser("");
  }, []);

  function toggleAddMemberModal() {
    setIsAddMemberOpen(!isAddMemberOpen);
    if (isAddMemberOpen === true) {
      getAllMembersByUser("");
    }
  }

  function editMember(id) {
    setSelectedMemberId(id);
    toggleEditMemberModal();
  }

  function deleteMember(id, name) {
    setSelectedMemberId(id);
    setSelectedMemberName(name);
    toggleDeleteMemberModal();
  }

  function toggleEditMemberModal() {
    setIsEditMemberOpen(!isEditMemberOpen);
    if (isEditMemberOpen === true) {
      getAllMembersByUser("");
    }
  }

  function toggleDeleteMemberModal() {
    setIsDeleteMemberOpen(!isDeleteMemberOpen);
    if (isDeleteMemberOpen === true) {
      getAllMembersByUser("");
    }
  }

  function toggleViewMemberModal(each) {
    setSelectedMembers(each);
    setIsViewMemberOpen(!isViewMemberOpen);
  }

  function getAllMembersByUser(text) {
    setIsLoading(true);
    getAllMembers(text).then(resp => {
      setIsLoading(false);
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        setMembers(data);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }

  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");

  function canEditDelete(each) {
    // team-lead editing their own reportee
    if (
      role !== "ROLE_USER" && role === "ROLE_ADMIN" &&
      !SuperAdminUserList().includes(each.id.toLowerCase()) &&
      each.role === "ROLE_USER" && each.id !== userId &&
      each.teamLead && each.teamLead.id === userId
    ) {
      return { edit: true, delete: false };
    }
    if (role !== "ROLE_USER" && role === "ROLE_SUPER_ADMIN" && SuperAdminUserList().includes(each.id.toLowerCase())) {
      return { edit: true, delete: false };
    }
    if (role !== "ROLE_USER" && role === "ROLE_SUPER_ADMIN" && !SuperAdminUserList().includes(each.id.toLowerCase())) {
      return { edit: true, delete: true };
    }
    return { edit: false, delete: false };
  }

  return (
    <div>
      {/* Toolbar */}
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div className="relative w-full max-w-xs">
          <IoSearchOutline size={16} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            value={searchText}
            placeholder="Search member here.."
            onChange={(e) => {
              setSearchText(e.target.value);
              getAllMembersByUser(e.target.value);
            }}
            className="w-full rounded-lg border border-gray-200 bg-white py-2 pl-9 pr-3 text-sm text-gray-700 outline-none transition-colors focus:border-[#262673] focus:ring-2 focus:ring-[#262673]/10"
          />
        </div>

        {role !== "ROLE_USER" && (
          <button
            onClick={toggleAddMemberModal}
            title="Add Member"
            className="flex h-11 w-11 items-center justify-center rounded-full bg-[#262673] text-white shadow-lg shadow-[#262673]/30 transition-all duration-300 hover:-translate-y-1 hover:scale-110 hover:bg-orange-500 hover:shadow-orange-500/30"
          >
            <TbUserPlus size={20} />
          </button>
        )}
      </div>

      {/* Loading */}
      {isLoading && (
        <div className="flex items-center justify-center py-10">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-[#262673]" />
        </div>
      )}

      {/* Member grid */}
      {!isLoading && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {members && members.length > 0 ? (
            members.map((each, ind) => {
              const perms = canEditDelete(each);
              const isActive = each.status === "ACTIVE";
              return (
                <div
                  key={ind}
                  className="group flex items-center gap-3 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-[#262673]/10 hover:shadow-lg"
                >
                  {/* Avatar with status ring */}
                  <button
                    onClick={() => toggleViewMemberModal(each)}
                    className="relative shrink-0"
                  >
                    <div className="relative h-14 w-14">
                      {isActive && (
                        <span className="absolute inset-0 blink rounded-full bg-green-400/40" />
                      )}
                      <img
                        src={each.gender === "male" ? profile : profile1}
                        alt={each.firstName}
                        className={`relative h-14 w-14 rounded-full border-2 object-cover ${
                          isActive ? "border-green-400" : each.status === "DROP" ? "border-gray-300" : "border-gray-200"
                        }`}
                      />
                      <span
                        className={`absolute bottom-0 right-0 h-3.5 w-3.5 rounded-full border-2 border-white ${
                          isActive ? "bg-green-500" : each.status === "DROP" ? "bg-gray-300" : "bg-gray-400"
                        }`}
                      />
                    </div>
                  </button>

                  {/* Info */}
                  <button
                    onClick={() => toggleViewMemberModal(each)}
                    className="min-w-0 flex-1 text-left"
                  >
                    <p className="truncate text-sm font-bold text-[#262673]">
                      {each.firstName.toUpperCase()} {each.lastName.toUpperCase()}
                    </p>
                    <p className="truncate text-xs text-gray-400">{each.designation}</p>
                  </button>

                  {/* Actions */}
                  {(perms.edit || perms.delete) && (
                    <div className="flex shrink-0 flex-col gap-1 opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                      {perms.edit && (
                        <button
                          onClick={() => editMember(each.id)}
                          title="Edit"
                          className="flex h-7 w-7 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-green-50 hover:text-green-600"
                        >
                          <IoPencil size={14} />
                        </button>
                      )}
                      {perms.delete && (
                        <button
                          onClick={() => deleteMember(each.id, each.firstName + " " + each.lastName)}
                          title="Delete"
                          className="flex h-7 w-7 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-red-50 hover:text-red-500"
                        >
                          <IoTrashOutline size={14} />
                        </button>
                      )}
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <div className="col-span-full flex flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-gray-200 py-16 text-gray-400">
              <TbUserPlus size={28} className="text-gray-300" />
              <p className="text-sm font-medium">No members found</p>
            </div>
          )}
        </div>
      )}

      {/* Add member modal */}
      {isAddMemberOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-[420px] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <AddMembers addMemberModal={toggleAddMemberModal} />
          </div>
        </div>
      )}

      {/* Edit member modal */}
      {isEditMemberOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-[420px] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <EditMembers editMemberModal={toggleEditMemberModal} selectedMemberId={selectedMemberId} />
          </div>
        </div>
      )}

      {/* View member modal */}
      {isViewMemberOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-[420px] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <ViewMembers viewMemberModal={toggleViewMemberModal} member={selectedMembers} />
          </div>
        </div>
      )}

      {/* Delete member modal */}
      {isDeleteMemberOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-[420px] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <MemberDelete deleteMembersModal={toggleDeleteMemberModal} memberId={selectedMemberId} name={selectedMemberName} />
          </div>
        </div>
      )}
    </div>
  );
}